import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 7,
	viewBox: "0 0 12 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 6L6 0.999999L1 6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronUp;
